<div class="about-container">
  <div class="story-section" #section>
    <div class="title">
      <div class="main-title yellow-heading">Our Story</div>
      <div class="sub-title">
        <span class="logo-name">The <span class="lab">Lab</span>oratory Matters</span>
        is about all things that MATTER in a clinical laboratory . In today's medical practice over
        <br />75% of decisions are
        based on laboratory results.
      </div>
    </div>
    <div class="image-section">
      <div class="image" *ngFor="let item of imageList">
        <img [src]="item.src" alt="item.title" />
        <div class="image-caption">
          {{ item.title }}
        </div>
      </div>
    </div>
    <div class="content">
      <span class="logo-name">The <span class="lab">Lab</span>oratory Matters</span>
      is a structured program that provides customised and personalised training that often is not completely provided
      due to the pressing demands of the busy clinical laboratory.
    </div>
  </div>
  <div class="sail-smooth-section" #section>
    <div class="content">
      <div class="left-section">
        <img src="../../assets/images/Artboard 3.png" alt="" loading="lazy" decoding="async" />
      </div>
      <div class="right-section">
        <div class="title two-liner">
          Learning never exhausts the mind. <br> TLM encourages learning and growing together.
        </div>
        <div class="top-section">
          <div class="italics">
            Unlearn, Learn and Upskill at your pace
          </div>
          <div class="explore-btn">
            <button (click)="onClickExploreCourses()">Explore</button>
          </div>
        </div>
        <div class="bottom-section">
          <div class="quote-icon left-icon">
            <i class="fa-solid fa-quote-left"></i>
          </div>
          <div class="right-section-content">
            <div>
              <span class="logo-name">The <span class="lab">Lab</span>oratory Matters</span>
              offers remote learning at ones’ own pace -Learn what I want and when I want.
            </div>
            <div>
              TLM’s subscription model allows you to personalise your choice of courses and duration. With TLM, you can
              stay in touch with your instructor, clear your doubts and revisit the learning.
            </div>
          </div>
          <div class="quote-icon right-icon">
            <i class="fa-solid fa-quote-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="team-section" #section>
    <div class="title yellow-heading">Meet the Expert</div>
    <div class="members">
      <div class="left" (click)="onClickImage('about RR')" data-toggle="modal" data-target="#exampleModalCenter">
        <img src="../../assets/images/intro_rr.png" alt="" loading="lazy" decoding="async" />
      </div>
    </div>
  </div>
  <div class="values-section" #section>
    <div class="content" #valuesSection>
      <div class="left-section">
        <div class="top-section">
          The laboratory is not just about samples. It is the journey that a
          sample makes from a patient to the report generated.
        </div>
        <div class="bottom-section">
          In order to deliver an accurate and credible report, the laboratory
          operations begin with the right test, right patient preparation, right
          sample, right method, right report and right interpretation. The
          overall laboratory management process is carried out by the laboratory
          medicine expert along with a team of trained technologists and
          scientists, besides the support team.
        </div>
      </div>
      <div class="right-section">
        <div class="bottom-section">
          Laboratory medicine is making such giant strides and it is imperative
          for all laboratarians to keep abreast. <br />
          <span class="logo-name">The <span class="lab">Lab</span>oratory Matters</span>
          provides a platform for you to do just that at your pace in the
          comfort of your home. With several years of laboratory experience
          between us, the core team has put together courses that form the
          essence of day to day laboratory work.
        </div>
        <div class="top-section">
          So just dive in and set sail on this exciting journey of discovery and
          rediscovery.
        </div>
      </div>
    </div>
    <div class="title">
      <div class="main-title yellow-heading">What we stand for</div>
      <div class="sub-title">EXPERTISE EMPOWERS EXCELLENCE</div>
    </div>
    <div class="sections">
      <div class="section">
        <div class="title">OUR MISSION</div>
        <div class="content">
          <ul>
            <li>
              Our mission is to provide innovative, cost effective, value-based
              training delivered by committed and passionate trainers and
              leaders to enable the learners in their professional development
              and quest for excellence.
            </li>
          </ul>
        </div>
      </div>
      <div class="section">
        <div class="title">OUR VISION</div>
        <div class="content">
          <ul>
            <li>
              To become the preferred training provider beyond boundaries in the
              realm of laboratory medicine, thus enabling professional growth
              and clarity enhancing performance.
            </li>
          </ul>
        </div>
      </div>
      <div class="section">
        <div class="title">OUR VALUES</div>
        <div class="content">
          <ul>
            <li>Innovative training and learning</li>
            <li>Quest for excellence</li>
            <li>Leadership</li>
            <li>Passion</li>
            <li>Collaboration</li>
          </ul>
        </div>
      </div>
      <div class="section">
        <div class="title">OUR GOALS</div>
        <div class="content">
          <ul>
            <li>To make smart laboratories</li>
            <li>To make zero-error laboratories</li>
            <li>To share expertise, information and empathy.</li>
            <li>
              To enable a collaborative platform for all laboratory medicine
              experts
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div [ngClass]="displayImage ? 'active-popup' : 'inactive-popup'" (click)="displayImage = false">
    <div class="popup-image" (click)="displayImage = true">
      <img [src]="'../../assets/images/' + selectedImage + '.png'" alt="" />
    </div>
  </div>
</div>